export const iconFontAwesomeConstructionToiletPortable = (
	<i className="fa-solid fa-toilet-portable"></i>
);
